import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  "chartOption.regionName": "选中区域名称",
  refreshTime: "间隔刷新时间",
  updateTimer: "数据源轮询时间",
  restDataUrl: "外接数据源地址",
  name: "当前地图",
  deepMap: "开启下钻",
  zoom: "地图缩放",
  center: "地图中心点经纬度",
  areaColor: "地图区块颜色",
  primaryBorderColor: "地图边框颜色",
  primaryBorderWidth: "地图边界默认border宽度",
  selectBorderColor: "地图边框颜色",
  selectColor: "地图选中和hover的颜色",
  selectBorderWidth: "地图边界选中border宽度",
  showLabel: "显示地图标签",
  showScatter: "显示散点图",
  showHot: "显示热力图",
  showLines: "显示飞线图",
  showBar: "显示柱状图",
  "label.labelFontColor:": "地图标签字体颜色",
  "label.labelFontFamily": "地图标签字体样式",
  "label.labelFontSize": "地图标签字体大小",
  "label.labelFontWeight": "地图标签字体粗细",
  "select.selectFontColor:": "选中标签字体颜色",
  "select.selectFontFamily": "选中标签字体样式",
  "select.selectFontSize": "选中标签字体大小",
  "select.selectFontWeight": "选中标签字体粗细",
  "chartOption.scatter.selectName": "散点名称",
  "scatter.label.show": "散点标签字体显示",
  "scatter.label.labelFontColor": "散点标签字体颜色",
  "scatter.label.labelFontFamily": "散点标签字体样式",
  "scatter.label.labelFontSize": "散点标签字体大小",
  "scatter.label.labelFontWeight": "散点标签字体粗细",
  "scatter.label.offset": "散点标签字体偏移",
  "lines.data": "飞线数据",
  "lines.centerData": "飞线中心点数据",
  "lines.lineStyle.color": "飞线颜色",
  "lines.lineStyle.width": "飞线粗细",
  "lines.lineStyle.type": "飞线样式",
  "lines.effect.show": "飞线图标显示",
  "lines.effect.symbolSize": "飞线图标大小",
  "lines.effect.period": "飞线图标速度",
  "lines.effect.symbol": "飞线图标",
  "lines.effect.trailLength": "飞线图标尾迹长度",
  "bar.data": "柱状图数据",
  "bar.barSize": "柱体大小",
  "bar.minHeight": "最小柱体高度",
  "bar.animationDurationUpdate": "柱状图动画时间",
  "bar.label.distance": "柱体标签纵向偏移",
  "bar.label.fontSize": "柱体标签字体大小",
  "bar.label.fontFamily": "柱体标签字体类型",
  "bar.label.color": "柱体标签字体颜色",
  "bar.label.fontWeight": "柱体标签字体粗细",
  "chartOption.visualMap.hotName": "热力名称",
  "visualMap.type": "热力图图标类型",
  "visualMap.orient": "热力图图标方向",
  "visualMap.min": "热力图最小值",
  "visualMap.max": "热力图最大值",
  "visualMap.mapStartColor": "热力图最小值颜色",
  "visualMap.mapEndColor": "热力图最大值颜色",
  "visualMap.showHandleIcon": "热力图是否显示拖拽手柄",
  "visualMap.left": "热力图左位置",
  "visualMap.top": "热力图上位置",
  "geo3D.regionHeight": "3D地图厚度",
  "geo3D.viewControl.alpha": "3D地图纵向旋转角度",
  "geo3D.viewControl.beta": "3D地图横向旋转角度",
  "geo3D.viewControl.zoomSensitivity": "3D地图缩放系数",
  "geo3D.viewControl.rotateSensitivity": "3D地图旋转系数"
}
export const getOptDes = toSelectOpt.bind(this, optDes)
